export const formatter = new Intl.DateTimeFormat('de-DE',
    { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export function newestTimestamp(timestmps: any[]) {
    const valid = [...timestmps].filter(ts => !!ts);

    if (valid.length === 0) {
        return null;
    }

    return Math.max(...valid.map(ts => new Date(ts).getTime()));
}

export function getFromToTimestampsPair() {
    const toTimestamp = new Date().getTime();

    const toDate = toTimestamp ? new Date(toTimestamp) : new Date();
    const toMonth = toDate.getMonth();
    const oneMonthAgo = new Date(toDate.setMonth(toMonth - 1));
    const fromTimestamp = oneMonthAgo.getTime()

    return {
        from: fromTimestamp,
        to: toTimestamp,
    }
}